/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1NotificationMobileAppSharedEnrollmentTypesQueryResponse,
  GetApiV1NotificationMobileAppSharedEnrollmentTypes401,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppSharedEnrollmentTypes.ts";

function getGetApiV1NotificationMobileAppSharedEnrollmentTypesUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/notification/mobile-app/shared/enrollment-types` as const,
  };
  return res;
}

/**
 * @description Lista os valores do enum EEnrollmentStatus com id e nome. **(Requer Authorization para autenticação)**
 * @summary Retorna os tipos de status de matrícula disponíveis (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app/shared/enrollment-types}
 */
export async function getApiV1NotificationMobileAppSharedEnrollmentTypes(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1NotificationMobileAppSharedEnrollmentTypesQueryResponse,
    ResponseErrorConfig<GetApiV1NotificationMobileAppSharedEnrollmentTypes401>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1NotificationMobileAppSharedEnrollmentTypesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
